import moment from 'moment';
import { DateComponent } from '../datepicker';
import { Dropdown } from '../dropdown';
import clsx from 'clsx';
import { useState } from 'react';

export function InputDate({
  label,
  value,
  onChange,
  format = 'D/M/YYYY',
  classes = {},
  helperText
}: {
  label?: string;
  value: string | moment.Moment; // Accept both string and moment object
  onChange: (date: Date) => void;
  format?: string;
  classes?: Record<string, string>;
  helperText?: string;
}) {
  const inputClasses = clsx(
    'block',
    'w-[calc(100%-4px)]',
    'rounded-md',
    'bg-white',
    'px-3',
    'py-1.5',
    'text-base',
    'text-slate-900',
    'ring-1',
    'ring-slate-300',
    'placeholder:text-slate-400',
    'focus:ring-2',
    'focus:ring-blue-600',
    'sm:text-sm/6',
    'm-[2px]',
    'cursor-pointer',
    'hover:bg-slate-50',
    'hover:ring-blue-600'
  );
  const [isOpened, setIsOpened] = useState<boolean>(false);

  // Format the date value based on its type
  const formatValue = () => {
    if (!value) return '';

    // If value is already a moment object
    if (moment.isMoment(value)) {
      return value.format(format);
    }

    return '';
  };

  // Hand the raw value to DateComponent, which parses it with moment. Formatting a
  // moment first would round-trip it through a localised, ambiguous string
  // (moment('17/7/2026') is unparseable), silently dropping the current selection.
  const getDateValue = () => value || '';

  return (
    <div>
      {label && <label className="text-sm mb-1 font-hmedium">{label}</label>}
      <Dropdown
        isOpened={isOpened}
        setIsOpened={setIsOpened}
        zIndex={classes.dropdown}
        button={
          <>
            <input
              placeholder="Sélectionner une date"
              className={inputClasses}
              value={formatValue()}
              type="text"
              readOnly
            />
            {helperText && <div className="text-xs text-gray-500 mt-1">{helperText}</div>}
          </>
        }
      >
        <div>
          <DateComponent
            value={getDateValue()}
            onChange={date => {
              setIsOpened(false);
              onChange(date);
            }}
          />
        </div>
      </Dropdown>
    </div>
  );
}
